<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ManualProcessing from './ManualProcessing/index.vue';
import ScheduledTasks from './ScheduledTasks/index.vue';
export default {
	components: {
		ScheduledTasks,
		ManualProcessing
	},
	data() {
		return {
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			activeName: 'ScheduledTasks',
			overlength: 0,
			list: ''
		};
	},
	mounted() {},
	created() {
		this.list = this.searchdata;
	},
	methods: {
		//搜索
		submitSearch() {
			this.$nextTick(() => {
				this.list = JSON.parse(JSON.stringify(this.searchdata));
				if (this.activeName == 'ScheduledTasks') {
					this.$refs.list = JSON.parse(JSON.stringify(this.searchdata));
					this.$refs.Tasks.initialization();
				} else if (this.activeName == 'ManualProcessing') {
					this.$refs.list = JSON.parse(JSON.stringify(this.searchdata));
					this.$refs.Processing.initialization();
				}
			});
		},
		geOoverLength(e) {
			this.overlength = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
